import React from 'react'
import { styled, keyframes } from 'styled-components'
import { DeathIcon } from '../../../assets/icons'
import type { CrewDeathStatus } from '@mission.io/mission-toolkit'
import { STATIC_BACKGROUND_URL } from '../../../assets/constants'

type Props = { height: ?number, width: ?number, deathState: CrewDeathStatus }
export default function DeathScreen({
	height,
	width,
	deathState,
}: Props): React$Node {
	return (
		<DeathWrapper height={height} width={width}>
			<StyledDeath alt="Death" src={DeathIcon} />
			<DarkenedDiv>
				<CenterDiv>
					<Title>
						{(deathState.status === 'FAILED_STATE' ||
							deathState.status === 'SHIP_DEATH') &&
							deathState.mainScreenText}
					</Title>
					<Info>Try Again?</Info>
				</CenterDiv>
			</DarkenedDiv>
		</DeathWrapper>
	)
}

const fadeIn = keyframes`
	0% {
		opacity: 0;
	}
	100% {
		opacity: 1;
	}
`

const DeathWrapper = styled.div.attrs({ className: 'font-game-headline' })`
	display: flex;
	justify-content: center;
	align-items: center;
	${({ height, width, theme }) => `
        height:${height}px;
        width: ${width}px;
        color: ${theme.error};
        font-weight: ${theme.fontBold};
    `}
	background-image: url(${STATIC_BACKGROUND_URL});
	letter-spacing: 2px;
	animation: ${fadeIn} 3000ms;
`

const StyledDeath = styled.img`
	position: absolute;
	opacity: 0.5;
	top: 18%;
`

const DarkenedDiv = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: rgba(0, 0, 0, 0.5);
	width: 100%;
	height: 100%;
`

const CenterDiv = styled.div`
	text-align: center;
`

const Title = styled.div`
	font-size: ${({ theme }) => theme.fonthero};
	margin-bottom: ${({ theme }) => theme.spacing2x};
`
const Info = styled.div`
	font-size: 40px;
`
